import axios from 'axios';
import i18n from './../../../i18n';
import router from './../../routes';
import env from '../../../env';
import Vue from "vue";

const state = {
    teacher: {
        page: 'main'
    }
};

const mutations = {
    SET_TEACHER_PAGE (state, page) {
        state.teacher.page = page;
    },
};

const actions = {
    setTeacherPage: ({ commit }, page) => {
        commit('SET_TEACHER_PAGE', page)
    },

};

const getters = {
    teacher: state => {
        return state.teacher
    },
};


export default {
    state,
    mutations,
    actions,
    getters
}
